import React, { useEffect, useMemo, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import Header from "../../../layouts/Header.js";
import {
  DriveAdd,
  FetchZeroParentFolder,
  FetchSpireFolderDocuments,
  DeleteDriveFolderOrFile,
  SearchFolderFile,
} from "../../../redux/actions/action.js";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { API_URL } from "../../../redux/constants/type.js";
import { Tooltip, Progress, Empty } from "antd";
import {
  FilePdfTwoTone,
  FileWordTwoTone,
  FileTextTwoTone,
  FileTwoTone,
  CheckOutlined,
  SyncOutlined,
  EyeOutlined,
  ArrowDownOutlined,
  LoadingOutlined,
  FileTextOutlined,
  FilePdfOutlined,
  FileJpgOutlined,
  FileImageOutlined,
  FileWordOutlined,
  FilePptOutlined,
  FileExcelOutlined,
  JavaScriptOutlined,
} from "@ant-design/icons";
import moment from "moment";
import PlusImg from "../../../assets/icons/plus-circle-white.svg";
import send from "../../../assets/icons/send.svg";
import AIicon from "../../../assets/icons/AIicon.svg";
import bin from "../../../assets/icons/Bin.svg";
import PlusImgDotted from "../../../assets/icons/plus-dotted-blue-icon.svg";
import PlusImg2 from "../../../assets/icons/plus-circle2.svg";
import searchicon from "../../../assets/icons/search.svg";
import DragDropSpireAi from "./DragDropSpireAi-3.js";
import roundFileSize from "../../../utils/Documents/roundFileSize";
import { getFilePreview } from "../../../utils/filePreview/filePreview";
import FilePreviewModal from "../../../utils/filePreview/FilePreviewModal";
import "../../../assets/styles/local/SpireAI.css";
import { fetchScreenTranslations } from "../../../utils/helpers/translations";
import {
  getChatRooms,
  addIndividualGroups,
} from "../../../redux/actions/chatActions";

import { SPIRE_GPT, SPIRE_ACADEMY, findAssistantRoom } from "../../../utils/helpers/chatAssistants";
import { message as chatNotification } from "antd";

const SpireAi = () => {
  const dispatch = useDispatch();
  const [Ankit] = useAutoAnimate();
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;
  const hidden_Input_File = useRef(null);
  const eyeRef = useRef({});
  const userid = window.localStorage.getItem("userid");

  const driveAddFolderRes = useSelector(
    (state) => state.user.driveAddFolderRes,
  );
  const zeroParentsFolderRes = useSelector(
    (state) => state.user.zeroParentsFolderRes,
  );
  const searchAiFolderFileRes = useSelector(
    (state) => state.user.searchAiFolderFileRes,
  );
  const fetchSpireFolderDocumentsRes = useSelector(
    (state) => state.user.fetchSpireFolderDocumentsRes,
  );
  const deleteDriveFolderORFileRes = useSelector(
    (state) => state.user.deleteDriveFolderORFileRes,
  );
  const multipleUploadToS3Res = useSelector(
    (state) => state.user.multipleUploadToS3Res,
  );
  const filesInsertDocToS3Res = useSelector(
    (state) => state.user.filesInsertDocToS3Res,
  );
  const addDocRootRes = useSelector((state) => state.user.addDocRootRes);
  const ajitSpireJsonApiRes = useSelector(
    (state) => state.user.ajitSpireJsonApiRes,
  );
  const fileChunkCompleteRes = useSelector(
    (state) => state.user.fileChunkCompleteRes,
  );

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Spire_AI").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const [filePreview, setFilePreview] = useState(null);

  const [webHookLoader, setWebHookLoader] = useState({});
  const [showLoader, setShowLoader] = useState(true);
  const [fetchFolderData, setFetchFolderData] = useState([]);
  const [searchFolderName, setSearchFolderName] = useState("");
  const [childrenShow, setChildrenShow] = useState(false);
  const [folderID, setFolderID] = useState("");

  useEffect(() => {
    if (searchFolderName.trim() === "") {
      dispatch(FetchZeroParentFolder());
    } else {
      dispatch(SearchFolderFile({ querystring: searchFolderName }));
    }
  }, [searchFolderName]);

  useEffect(() => {
    if (searchAiFolderFileRes?.status) {
      setFetchFolderData(searchAiFolderFileRes.data || []);
      setShowLoader(false);
    }
  }, [searchAiFolderFileRes]);

  useEffect(() => {
    dispatch(FetchZeroParentFolder());
  }, [
    dispatch,
    driveAddFolderRes,
    deleteDriveFolderORFileRes,
    multipleUploadToS3Res,
    addDocRootRes,
    ajitSpireJsonApiRes,
  ]);

  useEffect(() => {
    if (addDocRootRes?.status) {
      setWebHookLoader((prev) => {
        const updated = { ...prev };
        addDocRootRes.data?.forEach((doc) => {
          updated[doc.documentid] = true;
        });
        return updated;
      });
    }
  }, [addDocRootRes]);

  useEffect(() => {
    if (ajitSpireJsonApiRes?.statusCode === 200) {
      setWebHookLoader((prev) => {
        const updated = { ...prev };
        ajitSpireJsonApiRes?.body?.data?.forEach((doc) => {
          updated[doc.documentid] = false;
        });
        return updated;
      });
    }
  }, [ajitSpireJsonApiRes]);

  useEffect(() => {
    if (zeroParentsFolderRes?.status === true) {
      const rootFolder = zeroParentsFolderRes?.data;
      setFetchFolderData(rootFolder);
      setShowLoader(false);
    } else if (zeroParentsFolderRes?.status === false) {
      setShowLoader(false);
    }
  }, [zeroParentsFolderRes]);

  const renderStructure2 = (node, level = 0) => {
    if (!node) return null;

    if (Array.isArray(node)) {
      return node.map((child) => renderStructure2(child, level));
    }

    if (node.type === "folder") {
      return (
        <div key={node.name}>
          <div style={{ marginLeft: level * 20, fontWeight: "bold" }}>
            📁 {node.name}
          </div>
          {renderStructure2(node.children, level + 1)}
        </div>
      );
    }

    if (node.type === "file") {
      return (
        <div key={node.name} style={{ marginLeft: level * 20 }}>
          📄 {node.name} {node.size}
        </div>
      );
    }

    return null;
  };

  const extensionType26 = (data = "file", data2) => {
    let fileExtension =
      data === "folder" || data2 === "folder" ? (
        "📁"
      ) : data === "txt" || data === "file" ? (
        <FileTextTwoTone /> || "📄"
      ) : data === ".pdf" ? (
        <FilePdfTwoTone />
      ) : data === ".doc" ? (
        <FileWordTwoTone />
      ) : data === ".js" ? (
        <FileTwoTone />
      ) : (
        <FileTwoTone /> || "?"
      );
    return fileExtension;
  };

  const extensionType2 = (type = "file", type2) => {
    let fileExtension =
      type2 === "folder" ? (
        "📁"
      ) : type === "txt" || type === "file" ? (
        <FileTextOutlined style={{ fontSize: "26px", color: "#C43E1C" }} />
      ) : type === ".csv" ? (
        <FileTextOutlined style={{ fontSize: "26px", color: "#107C41 " }} />
      ) : type === ".xls" || type === ".xlsx" || type === ".xlsm" ? (
        <FileExcelOutlined style={{ fontSize: "26px", color: "#107C41" }} />
      ) : type === ".docx" || type === "doc" ? (
        <FileWordOutlined style={{ fontSize: "26px", color: "#2B579A" }} />
      ) : type === ".ppt" || type === "pptx" ? (
        <FilePptOutlined style={{ fontSize: "26px", color: "#C43E1C" }} />
      ) : type === ".jpg" ||
        type === ".jpeg" ||
        type === ".png" ||
        type === ".gif" ? (
        <FileImageOutlined style={{ fontSize: "26px", color: "#E17B34 " }} />
      ) : type === ".pdf" ? (
        <FilePdfOutlined style={{ fontSize: "26px", color: "#FF0000" }} />
      ) : type === ".svg" ? (
        <FileImageOutlined style={{ fontSize: "26px", color: "#E17B34" }} />
      ) : type === ".js" ? (
        <JavaScriptOutlined style={{ fontSize: "26px", color: "#F7DF1E" }} />
      ) : (
        <FileTextOutlined style={{ fontSize: "26px", color: "#C43E1C" }} />
      );

    return fileExtension;
  };

  const openingAssistantChat = useRef(false);
  const goToChat = async (assistant = SPIRE_GPT) => {
    if (openingAssistantChat.current) return;
    openingAssistantChat.current = true;
    try {
      const rooms = await dispatch(getChatRooms(userid));
      let roomId = findAssistantRoom(rooms, assistant)?.groupid;
      if (!roomId) {
        const result = await dispatch(addIndividualGroups(userid, "", [
          { groupmember: assistant.userId },
          { groupmember: userid },
        ]));
        roomId = result?.status && result?.data?.[0]?.groupid;
        if (!roomId) throw new Error(result?.message || "Conversation creation failed");
      }
      history.push(`/chat?room=${roomId}`);
    } catch (error) {
      console.error(`Error opening ${assistant.name} chat:`, error);
      chatNotification.error(`Unable to open ${assistant.name} chat. Please try again.`);
    } finally {
      openingAssistantChat.current = false;
    }
  };

  const showTooltipComp = (item) => {
    return (
      <div>
        {item.status === "Ready" ? (
          <>
            <div
              className="spireText5 d-flex gap-3 py-1 px-3 pointer"
              onClick={() => {
                goToChat();
              }}
            >
              <p className="spireText1 fw-medium">SpireGPT</p>
              <img src={send} alt="" width={18} />
            </div>
            <div
              className="spireText5 d-flex gap-3 py-1 px-3 pointer"
              onClick={() => goToChat(SPIRE_ACADEMY)}
            >
              <p className="spireText1 fw-medium">Spire Academy</p>
              <img src={send} alt="" width={18} />
            </div>
          </>
        ) : item.status === "Structuring Data" ? (
          <div>
            <div className="spireText1 d-flex gap-2 pt-2">
              <p className="spireText4">2</p>
              <p className="mb-0">Structuring data</p>
            </div>
            <p className="spireText2 pt-1">
              Text being extracted from images and segment the document to
              understand its content. This ensures the information is
              well-organized and ready for processing.
            </p>
            <p className="spireText3 pt-2 pe-1 text-end">Step 2/4</p>
          </div>
        ) : item.status === "Creating AI Database" ? (
          <div>
            <div className="spireText1 d-flex gap-2 pt-2">
              <p className="spireText4">4</p>
              <p className="mb-0">Creating AI Datanase</p>
            </div>
            <p className="spireText2 pt-1">
              The extracted data is converted into vectors (mathematical
              representations) and enriched with metadata such as document type,
              date, or relevant tags. All information is stored in a scalable
              vector database to enable fast and efficient searching.
            </p>
            <p className="spireText3 pt-2 pe-1 text-end">Step 4/4</p>
          </div>
        ) : item.status === "Layout analysis" ? (
          <div>
            <div className="spireText1 d-flex gap-2 pt-2">
              <p className="spireText4">3</p>
              <p className="mb-0">Layout analysis</p>
            </div>
            <p className="spireText2 pt-1">
              The document’s structure is being analyzed and classified. This
              makes it easier to search and filter information later, based on
              various components such as headings, tables, or text blocks.
            </p>
            <p className="spireText3 pt-2 pe-1 text-end">Step 3/4</p>
          </div>
        ) : item.status === "Data received" ? (
          <div>
            <div className="spireText1 d-flex gap-2 pt-2">
              <p className="spireText4">1</p>
              <p className="mb-0">Data received</p>
            </div>
            <p className="spireText2 pt-1">
              The document is securely stored in the AI environment of the Spire
              Connect database, making it easily accessible for further
              processing.
            </p>
            <p className="spireText3 pt-2 pe-1 text-end">Step 1/4</p>
          </div>
        ) : item.status === "Parked" ? (
          <div>
            <div className="spireText1 d-flex gap-2 pt-2">
              <p className="spireText4">1</p>
              <p className="mb-0">Parked</p>
            </div>
            <p className="spireText2 pt-1">
              The document has been securely stored and parked, pending review,
              validation, or further processing.
            </p>
            <p className="spireText3 pt-2 pe-1 text-end d-none">Step 1/4</p>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };

  // Callback function to receive data from child start.
  const [dataFromChild, setDataFromChild] = useState([]);
  console.log("asc child Data", dataFromChild);

  const handleDataFromChild = (data) => {
    setDataFromChild(data);
  };
  // Callback function to receive data from child end.

  return (
    <>
      <Header
        setQuery={setSearchFolderName}
        leftComponent={
          <div className="headerContainer">
            <div
              className="dashboardTitle pointer"
              onClick={() => history.push("/Spire-AI")}
            >
              {/* AI Drive */}
              {t("AI Drive")}
            </div>
          </div>
        }
      />

      <div className="ps-4 col-11 col-lg-4 d-none">
        <section className="asc_Search_Icon_Search mx-2 w-100">
          <input
            id="asc_input"
            className="asc_Search_Input w-100"
            // placeholder="Search..."
            placeholder={t("Search...")}
            value={searchFolderName}
            onChange={(e) => setSearchFolderName(e.target.value)}
          />
          <img src={searchicon} alt="" className="asc_searchicon me-2" />
        </section>
      </div>

      <div
        className="mx-3"
        style={{
          position: "relative",
          overflow: "auto",
          height: "350px",
          maxHeight: "350px",
        }}
      >
        <table className="table">
          <thead>
            <tr className="tableHeading-NewInvoice z-1">
              <th style={{ width: "2%" }}></th>
              <th style={{ width: "35%" }}>
                {/* AI Folder Name */}
                {t("AI Folder Name")}
              </th>
              <th style={{ width: "12%" }}>
                {/* Creation Date */}
                {t("Creation Date")}
              </th>
              <th style={{ width: "20%" }}>
                {/* Owner */}
                {t("Owner")}
              </th>
              <th style={{ width: "10%" }}>
                {/* File Size */}
                {t("File Size")}
              </th>
              <th>
                {/* AI Status */}
                {t("AI Status")}
              </th>
              <th>
                {/* Logo */}
                <img
                  src={AIicon}
                  alt=""
                  className="opacity-50"
                  style={{
                    width: "20px",
                    height: "25px",
                  }}
                />
              </th>
              <th></th>
              <th></th>
            </tr>
          </thead>

          <tbody
            className="tabLine"
            style={{ borderTop: "1px dotted" }}
            ref={Ankit}
          >
            {fetchFolderData
              ?.filter((x) =>
                x.name?.toLowerCase().includes(searchFolderName?.toLowerCase()),
              )
              ?.map((item, index) => {
                return (
                  <tr
                    className="trHover"
                    style={{ borderBottom: "1px dotted" }}
                    key={index}
                    onClick={() => {
                      setFolderID(item.id);
                    }}
                  >
                    <td></td>
                    <td className="foldertxt">
                      <div
                        className="d-flex align-items-baseline gap-2 pointer"
                        onClick={() => {
                          if (item.type === "folder") {
                            history.push(`/Spire-AI-folder/${item.id}`);
                            setChildrenShow(!childrenShow);
                          } else {
                            // window.open(
                            //   item.link,
                            //   "_blank",
                            //   "noopener,noreferrer",
                            // );
                            eyeRef.current[item.id]?.click();
                          }
                        }}
                      >
                        <span className="fs-5">
                          {extensionType2(item.extension, item.type)}
                        </span>
                        <span>{item.name}</span>
                      </div>

                      {childrenShow && folderID === item.id && (
                        <div className="ps-4 pt-2">
                          {item.children.map((x, i) => (
                            <div className="d-flex gap-2 align-items-center">
                              <span className="foldertxt">📄</span>
                              <p className="mb-0" key={i}>
                                {x.name}
                              </p>
                            </div>
                          ))}
                        </div>
                      )}
                    </td>
                    <td className="foldertxt">
                      {moment(item.created_at).format("DD.MM.YYYY") || "_"}
                    </td>
                    <td className="foldertxt">{item.ownername || "_"}</td>
                    <td className="foldertxt">
                      {/* {roundFileSize(item.size) || "_"} */}
                      {item?.size === null ? "_" : roundFileSize(item.size)}
                    </td>
                    <td className="foldertxt">
                      {item.type === "file" ? (
                        !webHookLoader[item.id] && item?.status ? (
                          <Tooltip
                            title={showTooltipComp(item)}
                            color={"white"}
                            overlayInnerStyle={{
                              color: "black",
                              fontWeight: "500",
                            }}
                          >
                            {item.status}
                          </Tooltip>
                        ) : (
                          <LoadingOutlined />
                        )
                      ) : (
                        "_"
                      )}
                    </td>
                    <td className="foldertxt">
                      <Progress
                        type="circle"
                        size={22}
                        strokeWidth={25}
                        percent={
                          item.status === "Ready"
                            ? 100
                            : item.status === "Structuring Data"
                              ? 60
                              : item.status === "Creating AI Database"
                                ? 80
                                : item.status === "Layout analysis"
                                  ? 40
                                  : item.status === "Data received"
                                    ? 20
                                    : 0
                        }
                        format={() => ""} // inner text hide karega.
                        strokeColor="green" // circle ka color green karega.
                        // strokeColor={item.percent > 50 ? "green" : "orange"}
                        trailColor="#ddd"
                        // format={(percent) =>
                        //   percent === 100 ? (
                        //     <div
                        //       style={{
                        //         background: "green",
                        //         borderRadius: "50%",
                        //         display: "flex",
                        //         alignItems: "center",
                        //         justifyContent: "center",
                        //         color: "white",
                        //         fontSize: "12px",
                        //         fontWeight: 900,
                        //       }}
                        //     >
                        //       <CheckOutlined />
                        //     </div>
                        //   ) : (
                        //     ""
                        //   )
                        // } // ✅ 100 pe tick mark
                      />
                    </td>
                    <td className="foldertxt">
                      <img
                        src={bin}
                        alt=""
                        className="opacity-50 pointer"
                        style={{
                          width: "15px",
                          height: "15px",
                        }}
                        onClick={() => {
                          if (item.type === "file") {
                            dispatch(
                              DeleteDriveFolderOrFile(item.id, "rootdoc"),
                            );
                          } else {
                            dispatch(
                              DeleteDriveFolderOrFile(item.id, "folder"),
                            );
                          }
                        }}
                      />
                    </td>

                    <td className="foldertxt p-0 pointer">
                      {item?.type === "file" && (
                        <>
                          <ArrowDownOutlined
                            className="mx-3"
                            onClick={() => {
                              window.open(
                                item.link,
                                "_blank",
                                "noopener,noreferrer",
                              );
                            }}
                          />

                          <span>
                            <EyeOutlined
                              ref={(el) => (eyeRef.current[item.id] = el)}
                              onClick={() => {
                                setFilePreview(
                                  getFilePreview({
                                    // file: file, // local upload file
                                    url: item.link,
                                    type: item.link.split(".").pop(),
                                    name: item.name,
                                  }),
                                );
                              }}
                            />
                          </span>
                        </>
                      )}
                    </td>
                  </tr>
                );
              })}
            {fetchFolderData.length === 0 && (
              <tr>
                <td colSpan="8">
                  <div className="noDataDisplay text-center py-5">
                    {/* <Empty /> */}
                    {showLoader ? (
                      <p className="">
                        please wait while we fetching your data... &nbsp;{" "}
                        <SyncOutlined spin />
                      </p>
                    ) : (
                      <Empty />
                    )}
                  </div>
                </td>
              </tr>
            )}
            {fetchFolderData.length > 0 &&
              fetchFolderData.filter((x) =>
                x.name?.toLowerCase().includes(searchFolderName.toLowerCase()),
              ).length === 0 && (
                <tr>
                  <td colSpan="8">
                    <div className="noDataDisplay">
                      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    </div>
                  </td>
                </tr>
              )}
          </tbody>
        </table>
      </div>

      <FilePreviewModal
        open={filePreview}
        file={filePreview}
        onClose={() => setFilePreview(null)}
      />

      <DragDropSpireAi childData={handleDataFromChild} loader={setShowLoader} />
    </>
  );
};

export default SpireAi;
